import React, { ButtonHTMLAttributes } from "react"

import { Container } from "./style"

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean
}

const RegistersButton: React.FC<ButtonProps> = ({
  children,
  loading,
  ...rest
}) => <Container {...rest}>{loading ? "Carregando ..." : children}</Container>

export default RegistersButton
